import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Button from '../../../../../../incase-domain/components/button/Button';
import DropdownMenuCompact, {
    DropdownMenuCompactRef,
    DROPDOWN_MENU_COMPACT_SUBMENU_HOVER_OPEN_CLOSE_MS,
} from '../../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import {selectedPresentationSelector} from '../../../../../../store/selectors/presentation.selectors';

type MenuBarReportsDropdownProps = {
    reportsMenuItemRef: React.RefObject<DropdownMenuCompactRef>;
    onHoverEnter: () => void;
    mutateOnModified: (cb?: () => void) => void;
};

function MenuBarReportsDropdown({reportsMenuItemRef, onHoverEnter, mutateOnModified}: MenuBarReportsDropdownProps): JSX.Element {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const selectedPresentation = useSelector(selectedPresentationSelector);

    const reportsMenuItems = useMemo(
        () => [
            [
                {
                    label: t('menuBar.reportsMenu.presentationStatistics'),
                    icon: 'solar:chart-bold',
                    onClick: () => mutateOnModified(() => navigate(`/presentations/${selectedPresentation._id}/report`)),
                },
            ],
        ],
        [t, mutateOnModified, navigate, selectedPresentation._id]
    );

    return (
        <DropdownMenuCompact
            ref={reportsMenuItemRef}
            openOnMouseEnter
            closeOnMouseExit
            closeOnMouseExitDelayMs={DROPDOWN_MENU_COMPACT_SUBMENU_HOVER_OPEN_CLOSE_MS}
            onHoverEnter={onHoverEnter}
            items={reportsMenuItems}
        >
            <Button size="2xs" disableHover square variant="ghost" className="c-menuBar__button">
                {t('menuBar.reports')}
            </Button>
        </DropdownMenuCompact>
    );
}

export default React.memo(MenuBarReportsDropdown);
